import React from "react";
import Comments from "@common/components/shared/Comments";

const CustomerComments = ({ customerId }) => {
    return(
        <div className="mt-1_5 mr-1_5">
            <Comments customerId={customerId} />
        </div>
    )
}

export default CustomerComments;